module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo,
      "savoynet": _vm.imovel.savoynet
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Informações do imóvel")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.canEditInfo) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3 readonly-form",
    class: {
      'readonly-form--blocked': !_vm.canEditInfo
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "autocomplete": "off",
      "label": "Nome do imóvel",
      "name": "apelido",
      "data-vv-as": "nome do imóvel",
      "error-messages": _vm.errors.has('apelido') ? _vm.errors.first('apelido') : []
    },
    model: {
      value: (_vm.form.fields.apelido),
      callback: function($$v) {
        _vm.form.fields.apelido = $$v
      },
      expression: "form.fields.apelido"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.proprietarios,
      "label": "Dono do imóvel"
    },
    model: {
      value: (_vm.form.fields.proprietarioSelect),
      callback: function($$v) {
        _vm.form.fields.proprietarioSelect = $$v
      },
      expression: "form.fields.proprietarioSelect"
    }
  }), _vm._v(" "), (_vm.form.fields.proprietarioSelect === 'Preencher manualmente') ? _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "Nome do proprietário"
    },
    model: {
      value: (_vm.form.fields.proprietario),
      callback: function($$v) {
        _vm.form.fields.proprietario = $$v
      },
      expression: "form.fields.proprietario"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.tipos,
      "label": "Tipo do imóvel"
    },
    model: {
      value: (_vm.form.fields.tipoSelect),
      callback: function($$v) {
        _vm.form.fields.tipoSelect = $$v
      },
      expression: "form.fields.tipoSelect"
    }
  }), _vm._v(" "), (_vm.form.fields.tipoSelect === 'Preencher manualmente') ? _c('transition', {
    attrs: {
      "name": "slide-x-transition"
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "Tipo do imóvel"
    },
    model: {
      value: (_vm.form.fields.tipo),
      callback: function($$v) {
        _vm.form.fields.tipo = $$v
      },
      expression: "form.fields.tipo"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.form.fields.savoynet.length > 0) ? _c('div', {
    staticClass: "mb-2"
  }, _vm._l((_vm.form.fields.savoynet), function(item, index) {
    return _c('v-chip', {
      key: ("savoynet-" + item + "-" + index),
      staticClass: "mr-2 mb-2",
      attrs: {
        "close": _vm.canEditInfo
      },
      on: {
        "input": function($event) {
          _vm.removeSavoyNet(index)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])
  })) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "autocomplete": "off",
      "label": "SavoyNet",
      "hint": "Use Enter, vírgula, ponto e vírgula ou nova linha.",
      "persistent-hint": ""
    },
    on: {
      "keydown": _vm.onSavoyNetKeydown,
      "input": _vm.onSavoyNetInput,
      "blur": _vm.commitSavoyNetInput,
      "paste": _vm.onSavoyNetPaste
    },
    model: {
      value: (_vm.savoynetInput),
      callback: function($$v) {
        _vm.savoynetInput = $$v
      },
      expression: "savoynetInput"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "text-xs-center mt-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "acao-coluna",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.canDeleteInfo) ? _c('v-btn', {
    staticClass: "red red--text ma-0",
    attrs: {
      "outline": "",
      "block": "",
      "large": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openDialogExcluir($event)
      }
    }
  }, [_vm._v("\n                Excluir\n              ")]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "520"
    },
    model: {
      value: (_vm.dialogExcluir),
      callback: function($$v) {
        _vm.dialogExcluir = $$v
      },
      expression: "dialogExcluir"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Excluir imóvel?")]), _vm._v(" "), _c('v-card-text', [_c('strong', [_vm._v("ATENÇÃO:")]), _vm._v(" O imóvel não poderá ser recuperado após a exclusão.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogExcluir = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.excluirImovel($event)
      }
    }
  }, [_vm._v("Excluir")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.canEditInfo) ? _c('v-flex', {
    staticClass: "acao-coluna",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text ma-0",
    attrs: {
      "type": "submit",
      "outline": "",
      "block": "",
      "large": "",
      "disabled": _vm.isFormInvalid
    }
  }, [_vm._v("\n                Salvar\n              ")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.canViewFotos) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "to": ({
        name: 'ImoveisDetalhesFotos',
        params: {
          tipo: 'ilustrativa',
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("photo_library")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4993cea5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Detalhes/DetalhesInfo.vue
// module id = 1017
// module chunks = 1